/** Símbolo oficial de Omnisend, tomado de su paquete de prensa. */
export function OmnisendMark({ size = 18 }: { size?: number }) {
  return (
    <svg
      className="dash-brand-mark dash-omnisend-mark"
      width={size}
      height={size}
      viewBox="0 0 283.7 283.7"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#000"
        d="M234.45,0H49.15c-27.1,0-49.1,22-49.1,49.1v185.3c0,27.1,22,49.1,49.1,49.1h20.7h63.7v-40.6c0-39.1-4.8-69.2-33.9-77.8v-32c47.3,4.2,70.8,39.4,70.8,97.3v53.3h38.5h25.6c27.1,0,49.1-22,49.1-49.1V49.1C283.55,22,261.55,0,234.45,0 M143.25,102.4c-15,0-27.2-12.2-27.2-27.2s12.2-27.2,27.2-27.2s27.1,12.2,27.1,27.3C170.35,90.3,158.25,102.4,143.25,102.4"
      />
    </svg>
  )
}
